// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as RatgeberIndexRouteImport } from './routes/ratgeber.index'
import { Route as RatgeberSlugRouteImport } from './routes/ratgeber.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const RatgeberIndexRoute = RatgeberIndexRouteImport.update({
            id: '/ratgeber/',path: '/ratgeber/',getParentRoute: () => rootRouteImport
          })
const RatgeberSlugRoute = RatgeberSlugRouteImport.update({
            id: '/ratgeber/$slug',path: '/ratgeber/$slug',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,DatenschutzRoute: DatenschutzRoute,ImpressumRoute: ImpressumRoute,UnsubscribeRoute: UnsubscribeRoute,RatgeberSlugRoute: RatgeberSlugRoute,RatgeberIndexRoute: RatgeberIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)